export default (context, inject) => {
  const key = (modelName, verb) => {
    if (typeof modelName !== 'string') {
      throw new Error('Must provide a model name');
    }
    if (modelName === 'address') {
      return `utils/${verb}Address`;
    }
    if (modelName === 'banking') {
      return `utils/${verb}Banking`;
    }
    if (modelName === 'additionalDriver') {
      return `user/${verb}AdditionalDriver`;
    }
    if (modelName === 'customer') {
      return `user/${verb}Customer`;
    }
    if (modelName === 'jointCustomer') {
      return `user/${verb}JointCustomer`;
    }
    if (modelName === 'specifiedItem') {
      return `specifiedItem/${verb}`;
    }
    if (modelName === 'tempFilter') {
      return `search/${verb}Temp`;
    }
    if (modelName.toLowerCase().match(/search/)) {
      return `search/${verb}`;
    }
    if (modelName === 'user') {
      return `user/${verb}`;
    }
    return `order/${verb}`;
  };

  const formGet = (modelName, field, addressKey) => {
    const k = key(modelName, 'get');
    if (addressKey) {
      return context.store.getters[k](addressKey)[field];
    }
    return context.store.getters[k][field];
  };

  const formSet = (modelName, payload) => {
    context.store.commit(key(modelName, 'set'), payload);
  };

  inject('formGet', formGet);
  inject('formSet', formSet);
  context.$formGet = formGet;
  context.$formSet = formSet;
};
